<div class="container relative">
  <app-product-header [viewModel]="viewModel"
                      [skuId]="data.skuId"
                      [showDetailLink]="true"
                      [shareProductId]="viewModel.apiResult().meta?.productId"/>
  <button class="dialog-close" appFocusRemove mat-dialog-close>
    <app-image-loading src="assets/icon_close_gray.svg" alt="關閉" i18n-alt
                       [clickable]="true"
                       [targetWidth]="21"
                       [targetHeight]="21"/>
  </button>
</div>
